// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import "@hotwired/turbo-rails"
import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import 'materialize-css/dist/js/materialize'
import Inputmask from "inputmask";
import '../stylesheets/application'
import './toastr'
import "controllers"

Rails.start()
ActiveStorage.start()

document.addEventListener("turbo:before-stream-render", (event) => {
  if (event.target.action === "remove") {
    const targetFrame = document.getElementById(event.target.target)
    if (targetFrame == null) { return; }
    if (targetFrame.dataset.animateOut) {
      event.preventDefault()
      const elementBeingAnimated = targetFrame
      elementBeingAnimated.classList.add(targetFrame.dataset.animateOut)
      elementBeingAnimated.addEventListener("animationend", () => {
        targetFrame.remove()
      })
    }
  }
})


function addInputMask() {
  const input = document.querySelector('#permit_search_ripdes_number');
  if (input != null) { Inputmask("RI[A|9]{7}").mask(input); }
}
